import React, { Fragment } from 'react';
import { Box, Button, Card, Columns, Heading, Label, Link, Paragraph, Set, styled } from 'bumbag';
import format from 'date-fns/format';
import _get from 'lodash/get';
import Lever from 'react-lever';
import Loads from 'react-loads';

import HealthFundAccountBox from '@medipass/react-core/HealthFundAccounts/components/HealthFundAccountBox';
import { Link as RouterLink } from '@medipass/react-core/router';
import WithErrorMessage from '@medipass/react-core/WithErrorMessage';
import WithLoadingIndicator from '@medipass/react-core/WithLoadingIndicator';
import sdk from '@medipass/web-sdk';

import AddHealthFundAccount from 'legacy/components/account/health-fund-accounts/AddHealthFundAccount';
import AddMedicareDetails from 'legacy/components/account/health-fund-accounts/AddMedicareDetails';
import Page from 'legacy/components/account/layout/Page';
import WithAuthentication from 'legacy/components/WithAuthentication';
import WithEmpty from 'legacy/components/WithEmpty';
const SpacedRow = styled(Box)`
  display: flex;
  justify-content: space-between;
`;
export default class Members extends React.Component<{}> {
  getAccountMembers = () => {
    const accountId = _get(sdk, 'account._id');

    return sdk.members.getAccountMembers(accountId);
  };
  getHealthFundAccount = async (memberId: string, healthFundAccountId: string) => {
    const healthFundAccount = await sdk.healthFundAccounts.getMembersHealthFundAccount(memberId, healthFundAccountId);
    return healthFundAccount;
  };
  render = () => (
    <WithAuthentication>
      <Page minWidthBreakpoint="mobile" title="Members">
        <Box textAlign="right" marginBottom="major-2">
          <Button
            //@ts-expect-error

            use={RouterLink}
            palette="primary"
            variant="ghost"
            fontWeight="semibold"
            to="/account/members/create/"
          >
            <i className="fa fa-sm fa-plus margin-right-5" />
            Add a new member
          </Button>
        </Box>
        <Loads contextKey="accountMembers" loadOnMount load={this.getAccountMembers}>
          {/* @ts-expect-error TS(7031): Binding element 'getAccountMembers' implicitly has... Remove this comment to see the full error message */}
          {({ load: getAccountMembers, error, response, isError, isLoading, isSuccess }) => (
            <WithLoadingIndicator isActive={isLoading}>
              <WithErrorMessage isActive={isError} description="Unable to load your members" error={error}>
                <WithEmpty
                  isActive={isSuccess && _get(response, 'items.length', 0) === 0}
                  emptyText={<Card>You do not have any members attached to your account.</Card>}
                >
                  <Set display="block" orientation="vertical" spacing="major-2">
                    {/* @ts-expect-error TS(7006): Parameter 'member' implicitly has an 'any' type. */}
                    {_get(response, 'items', []).map((member, i) => (
                      <Card key={member._id} data-testid="view-members">
                        <SpacedRow>
                          <Heading use="h5" fontWeight="semibold">
                            {member.firstName} {member.lastName}
                          </Heading>
                          <Button
                            //@ts-expect-error

                            use={RouterLink}
                            variant="ghost"
                            palette="primary"
                            fontWeight="semibold"
                            to={`/account/members/edit/?id=${member._id}`}
                          >
                            <i className="fa fa-sm fa-pencil margin-right-5" />
                            Edit
                          </Button>
                        </SpacedRow>
                        <Columns minBreakpoint="mobile">
                          <Columns.Column spread={12} marginBottom="major-1">
                            <Label>Date of birth</Label>
                            <Paragraph>{member.dobString ? format(member.dobString, 'DD/MM/YYYY') : 'N/A'}</Paragraph>
                          </Columns.Column>
                          {member.email && (
                            <Columns.Column paddingTop="0px" marginBottom="major-1">
                              <Label>Email</Label>
                              <Paragraph>{member.email}</Paragraph>
                            </Columns.Column>
                          )}
                          {member.mobile && (
                            <Columns.Column paddingTop="0px">
                              <Label>Mobile</Label>
                              <Paragraph>{member.mobile}</Paragraph>
                            </Columns.Column>
                          )}
                          {member.defaultHealthFundAccountId && (
                            <Columns.Column spread={12} paddingTop="0px" marginBottom="major-1">
                              <Loads
                                contextKey={`healthFundAccount-${member._id}`}
                                loadOnMount
                                load={() => this.getHealthFundAccount(member._id, member.defaultHealthFundAccountId)}
                              >
                                {/* @ts-expect-error TS(7031): Binding element 'healthFundAccount' implicitly has... Remove this comment to see the full error message */}
                                {({ response: healthFundAccount, isLoading, isSuccess }) => (
                                  <WithLoadingIndicator isActive={isLoading}>
                                    {isSuccess && (
                                      <Fragment>
                                        <Label>Health fund</Label>
                                        <HealthFundAccountBox
                                          cardRank={_get(healthFundAccount, 'cardRank')}
                                          className="margin-top-10"
                                          healthFundName={_get(healthFundAccount, 'healthFund.displayName')}
                                          lastFour={_get(healthFundAccount, 'lastFour')}
                                          logoBackgroundColor={
                                            _get(healthFundAccount, 'healthFund.cardBgColorFront') ||
                                            _get(healthFundAccount, 'healthFund.primaryColor')
                                          }
                                          logoUrl={
                                            _get(healthFundAccount, 'healthFund.cardLogoUrl') ||
                                            _get(healthFundAccount, 'healthFund.logoSmallUrl')
                                          }
                                          memberName={`${member.firstName || ''} ${member.lastName || ''}`}
                                          membershipNumber={_get(healthFundAccount, 'membershipNumber')}
                                        />
                                      </Fragment>
                                    )}
                                  </WithLoadingIndicator>
                                )}
                              </Loads>
                            </Columns.Column>
                          )}
                          {member.medicareHealthFundAccountId && (
                            <Columns.Column spread={12} paddingTop="0px">
                              <Loads
                                contextKey={`medicareAccount-${member._id}`}
                                loadOnMount
                                load={() => this.getHealthFundAccount(member._id, member.medicareHealthFundAccountId)}
                              >
                                {/* @ts-expect-error TS(7031): Binding element 'medicareAccount' implicitly has a... Remove this comment to see the full error message */}
                                {({ response: medicareAccount, isLoading, isSuccess }) => (
                                  <WithLoadingIndicator isActive={isLoading}>
                                    {isSuccess && (
                                      <Fragment>
                                        <Label>Medicare</Label>
                                        <HealthFundAccountBox
                                          cardRank={_get(medicareAccount, 'cardRank')}
                                          className="margin-top-10"
                                          healthFundName={_get(medicareAccount, 'healthFund.displayName')}
                                          lastFour={_get(medicareAccount, 'lastFour')}
                                          logoBackgroundColor={
                                            _get(medicareAccount, 'healthFund.cardBgColorFront') ||
                                            _get(medicareAccount, 'healthFund.primaryColor')
                                          }
                                          logoUrl={
                                            _get(medicareAccount, 'healthFund.cardLogoUrl') ||
                                            _get(medicareAccount, 'healthFund.logoSmallUrl')
                                          }
                                          memberName={`${member.firstName || ''} ${member.lastName || ''}`}
                                          membershipNumber={_get(medicareAccount, 'membershipNumber')}
                                        />
                                      </Fragment>
                                    )}
                                  </WithLoadingIndicator>
                                )}
                              </Loads>
                            </Columns.Column>
                          )}
                        </Columns>
                        {i === 0 && !member.defaultHealthFundAccountId && (
                          <Box>
                            <hr />
                            <AddHealthFundAccount />
                          </Box>
                        )}
                        <Lever feature="medicare">
                          {i === 0 && !member.medicareHealthFundAccountId && (
                            <Box>
                              <hr />
                              <AddMedicareDetails />
                            </Box>
                          )}
                        </Lever>
                      </Card>
                    ))}
                    <Box textAlign="center" marginTop="major-4">
                      <Link
                        //@ts-expect-error

                        use={RouterLink}
                        fontWeight="semibold"
                        color="danger"
                        to="/account/delete/"
                        textDecoration="none"
                      >
                        <i className="fa fa-sm fa-trash-alt margin-right-5" />
                        Delete my account
                      </Link>
                    </Box>
                  </Set>
                </WithEmpty>
              </WithErrorMessage>
            </WithLoadingIndicator>
          )}
        </Loads>
      </Page>
    </WithAuthentication>
  );
}
